// src/context/ActivePageContext.jsx
import { createContext, useContext, useState } from 'react';

const ActivePageContext = createContext();

export function ActivePageProvider({ children }) {
  const [activePage, setActivePage] = useState('dashboard'); 

  return (
    <ActivePageContext.Provider value={{ activePage, setActivePage }}>
      {children}
    </ActivePageContext.Provider>
  );
}

export function useActivePage() {
  return useContext(ActivePageContext);
}
